import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react'
import Select from 'react-select'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'
import { UndoOutlined } from '@material-ui/icons'
import { getBaseURL } from 'utility/httpClient.util'
import Webcam from 'react-webcam'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import { debounceCallback } from 'utility/debounceCallback.util'
import { onUpdateCondition } from 'designer/component/action/condition/Action'

const ImageCapture = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, setFieldFormData, isUiChanged, setIsUiChanged } =
    designContext
  const formData = jsonForm.formData
  let { open, onClose, action, config, stateParent, isFileUpload } = props
  const {
    files: [files, setFiles],
  } = { ...(stateParent || { files: [] }) }
  const { captureType, captureField } = action
  const [selectScan, setSelectScan] = useState('webcam')
  const [file, setFile] = useState(null)
  const [capture, setCapture] = useState('')
  const webcamRef = useRef(null)
  const [deviceId, setDeviceId] = useState(null)
  const [devices, setDevices] = useState([])
  const [videoDevices, setVideoDevices] = useState([])
  const [rearCamera, setRearCamera] = useState(true)

  const handleDevices = useCallback(
    (mediaDevices) => setDevices(mediaDevices),
    [setDevices]
  )

  useEffect(() => {
    if (selectScan === 'webcam') {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
    }
    navigator.mediaDevices.enumerateDevices().then(handleDevices)
  }, [handleDevices])

  useEffect(() => {
    if (selectScan === 'webcam') {
      let videoDevice = devices.filter(({ kind }) => kind === 'videoinput')
      if (videoDevice.length > 0) {
        let newDevices = []
        videoDevice.forEach((device, index) => {
          newDevices.push({
            value: device.deviceId || `camera-${index + 1}`,
            label: device.label || `Camera ${index + 1}`,
            groupId: device.groupId,
          })
        })
        setVideoDevices(newDevices)
        setDeviceId(newDevices[0].value)
      } else {
        setVideoDevices([{ value: 'default', label: 'default' }])
        setDeviceId('default')
      }
    }
  }, [selectScan])

  const toggleCamera = () => setRearCamera(!rearCamera)

  const extensionFile = {
    image: 'image.jpg',
    audio: 'audio.mp3',
    video: 'video.mp4',
  }

  const undoCapture = () => {
    if (capture) {
      setCapture()
      setFile(file)
    }
  }

  const saveCapture = async () => {
    let preview = []
    let file = await imageCapture()
    if (!file) return
    preview = Object.assign(file, {
      preview: capture,
    })
    if (isFileUpload) {
      files.push(file)
      setFiles(files)
    } else if (captureField?.key) {
      let { key, isInsideDynamic } = captureField
      let files = [file]
      if (key) {
        let data = formData
        let { dynamicKey = '', dynamicName = '', dynamicIndex = 0 } = config
        if (isInsideDynamic) {
          setFieldFormData(`${dynamicName}.${dynamicIndex}.${key}`, files)
          objectPath.set(data, `${dynamicName}.${dynamicIndex}.${key}`, files)
          let status = {
            isOnChange: false,
            isDynamic: true,
            name: captureField?.name || key,
            dynamicName,
            dynamicKey,
            dynamicIndex,
          }
          debounceCallback(
            onUpdateCondition,
            [props, designContext, key, data, status],
            `onInputUpdateCondition-${dynamicKey}-${dynamicIndex}`
          )
          debounceCallback(
            onUpdateCondition,
            [props, designContext, dynamicKey, '', status],
            `onInputUpdateDynamicCondition-${dynamicKey}-${dynamicIndex}`
          )
        } else {
          setFieldFormData(key, files)
          objectPath.set(data, key, files)
          debounceCallback(
            onUpdateCondition,
            [props, designContext, key, data],
            'onInputUpdateCondition'
          )
        }
        objectPath.set(isUiChanged, key, { isRender: true })
        setIsUiChanged(isUiChanged)
      }
    }
    setFile(file)
    onClose()
  }

  const imageCapture = async () => {
    if (file) {
      URL.revokeObjectURL(file)
    }
    if (capture) {
      const response = await fetch(capture)
      const blob = await response.blob()
      const image = new File([blob], 'image.jpg', {
        type: blob.type,
      })
      return image
    }
    return
  }

  const twainCapture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot()
      setCapture(imageSrc)
    }
  }, [webcamRef])

  useEffect(() => {
    if (!open) {
      setSelectScan('')
      setCapture()
    }
  }, [open, capture])

  return (
    <Modal show={open} size="xl">
      <Modal.Header
        onHide={onClose}
        style={{
          backgroundColor: '#fff',
        }}
      >
        <h5
          className="mb-0"
          style={{
            color: '#000',
          }}
        >
          Image Capture
        </h5>
      </Modal.Header>
      <Modal.Body className="p-3">
        <Row className="my-1 p-1">
          <div className="border-secondary w-100">
            <div
              className="dz-thumb w-100 m-0 border-0"
              style={{ height: '480px' }}
            >
              {capture ? (
                <div className="w-100 d-flex">
                  <div className="dz-thumb-inner my-0 mx-auto">
                    <img
                      src={capture}
                      alt="capture"
                      className="w-100"
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                </div>
              ) : (
                <div className="w-100">
                  <div className="dz-thumb-inner my-0 mx-auto justify-content-center">
                    {selectScan === 'webcam' && deviceId ? (
                      <Webcam
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        audio={false}
                        videoConstraints={{
                          deviceId: deviceId,
                          facingMode: rearCamera ? 'environment' : 'user',
                        }}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Row>
        <Row className="p-1">
          <Col sm={6} lg={6} className="my-1">
            {selectScan === 'webcam' && (
              <Select
                isClearable
                type="select"
                placeholder="Select Camera"
                options={videoDevices}
                value={videoDevices.find((device) => device.value === deviceId)}
                onChange={(option) => setDeviceId(option?.value)}
              />
            )}
          </Col>
          <Col sm={6} lg={3}>
            <Button
              variant="outline-primary"
              className="w-100 p-1 my-1"
              onClick={(e) => undoCapture()}
            >
              <UndoOutlined size={16} /> Undo
            </Button>
            <Button
              variant="outline-primary"
              className="w-100 p-1 mb-1"
              onClick={toggleCamera}
            >
              <FeatherIcon icon="refresh-cw" size="16" className="mr-1" />
              เปลี่ยนกล้อง
            </Button>
          </Col>
          <Col sm={6} lg={3} className="my-1">
            <Button
              variant="outline-primary"
              className="w-100 p-1 mb-1"
              onClick={twainCapture}
              disabled={
                captureType === 'image' && selectScan === 'webcam'
                  ? false
                  : true
              }
            >
              <FeatherIcon icon="zap" size={16} /> Capture
            </Button>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className="d-flex justify-content-end">
          <Button
            variant="outline-primary"
            onClick={saveCapture}
            className="mr-2"
          >
            <FeatherIcon icon="check" size="16" className="mr-1" />
            ยืนยัน
          </Button>
          <Button variant="outline-secondary" onClick={onClose}>
            <FeatherIcon icon="x" size="16" className="mr-1" />
            ยกเลิก
          </Button>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}

export default ImageCapture
